// extracted by mini-css-extract-plugin
export default {"bg":"AirwallexPay_bg__sU3VW","divitem":"AirwallexPay_divitem__52diT"};